<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Cabezera de la pagina principal -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Formatos De Inspeccion</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Operacion</li>
                  <li class="breadcrumb-item active">Formatos De Inspeccion</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <!-- Cuerpo de la pagina -->
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <!-- Cabecera de la tarjeta -->
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <!-- Div que empuja el boton a la izquierda -->
                  <div class="col-md-11"></div>
                  <div class="col-md-1">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        data-target="#modal-form-formato-inspeccion-export"
                        v-if="
                          $store.getters.can('admin.formatosInspeccion.export')
                        "
                      >
                        <i class="far fa-file-excel"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        v-on:click="create()"
                        v-if="
                          $store.getters.can('admin.formatosInspeccion.create')
                        "
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.cabezera de la tarjeta -->
              <div class="card-body p-0">
                <table
                  id="renderLineas"
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead class="text-center">
                    <tr>
                      <th>
                        Nombre
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.nombre"
                          v-on:keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Línea de Negocio
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.linea_negocio_id"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="lineaNegocio in listasForms.lineasNegocios"
                            :key="lineaNegocio.id"
                            :value="lineaNegocio.id"
                          >
                            {{ lineaNegocio.nombre }}
                          </option>
                        </select>
                      </th>
                      <th class="align-middle">Gnv</th>
                      <th class="align-middle">Estado</th>
                      <th class="align-middle">Accion</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in formatosInspeccion.data" :key="item.id">
                      <td>{{ item.nombre }}</td>
                      <td>
                        <span v-if="item.linea_negocio">{{
                          item.linea_negocio.nombre
                        }}</span>
                        <span v-else>N/A</span>
                      </td>
                      <td class="text-center">
                        <i
                          :class="
                            item.gnv == 1
                              ? 'fas fa-check text-success fa-lg'
                              : 'fas fa-times text-danger fa-lg'
                          "
                        ></i>
                      </td>
                      <td class="text-center">
                        <span
                          :class="
                            item.estado == 1
                              ? 'badge badge-success'
                              : 'badge badge-danger'
                          "
                          >{{ item.nEstado }}</span
                        >
                      </td>
                      <td style="width: 120px">
                        <div class="btn-group float-right">
                          <button
                            type="button"
                            class="btn btn-sm btn-info"
                            v-on:click="exportarPdfEstructura(item)"
                            v-if="
                              $store.getters.can(
                                'admin.formatosInspeccion.show',
                              )
                            "
                            title="Exportar PDF solo estructura"
                          >
                            <i class="far fa-file-pdf"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm bg-navy"
                            data-toggle="modal"
                            data-target="#Modal_items"
                            v-if="
                              $store.getters.can(
                                'admin.formatosInspeccion.show',
                              )
                            "
                            v-on:click="edit(item)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            v-on:click="destroy(item.id)"
                            v-if="
                              $store.getters.can(
                                'admin.formatosInspeccion.delete',
                              )
                            "
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="formatosInspeccion.total">
                  <p>
                    Mostrando del <b>{{ formatosInspeccion.from }}</b> al
                    <b>{{ formatosInspeccion.to }}</b> de un total:
                    <b>{{ formatosInspeccion.total }}</b> Registros
                  </p>
                </div>
                <div class="float-left" v-else>
                  <p>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </p>
                </div>
                <pagination
                  :data="formatosInspeccion"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  class="float-right"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <FormatoInspeccionExport ref="FormatoInspeccionExport" />
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Loading from "../../../../../components/Loading";
import { required, minLength } from "vuelidate/lib/validators";
import FormatoInspeccionExport from "./FormatoInspeccionExport";

export default {
  name: "FormatosInspeccion",
  components: {
    pagination,
    FormatoInspeccionExport,
    Loading,
  },
  data() {
    return {
      formatosInspeccion: {},
      filtros: {
        nombre: null,
        linea_negocio_id: null,
      },
      listasForms: {
        lineasNegocios: [],
      },
      cargando: false,
    };
  },
  methods: {
    //metodo create
    create() {
      return this.$router.push({
        name: "/Admin/FormatosInspeccionForm",
        params: { accion: "Crear", id: 0 },
      });
    },
    getIndex(page = 1) {
      this.cargando = true; // Se inicia el loading de la pagina
      axios
        .get("/api/admin/formatosInspeccion?page=" + page, {
          params: this.filtros /* parametros que se pasan en la ruta */,
        })
        .then((response) => {
          this.formatosInspeccion = response.data;
          this.cargando = false;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
    save() {
      if (!this.$v.form.$invalid) {
        axios
          .post("/api/admin/itemsInspeccion", this.form)
          .then((response) => {
            document.getElementById("close-modal").click;
            this.form = {};
            this.getIndex(); //Lista de nuevo
            this.$swal({
              icon: "success",
              title: "Se guardo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    show(idItem) {
      axios
        .get("/api/admin/itemsInspeccion/show/" + idItem)
        .then((response) => {
          this.form = response.data;
        });
    },
    destroy(idlinea) {
      this.$swal({
        title: "Esta seguro de eliminar esta Item de inspeccion?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "No, Cancelar",
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios.delete("/api/admin/formatosInspeccion/" + idlinea).then(() => {
            this.getIndex();
            this.$swal({
              icon: "success",
              title: "Se elimino el item de manera exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          });
        }
      });
    },
    getLineasNegocios() {
      axios.get("/api/admin/lineasNegocios/lista").then((response) => {
        this.listasForms.lineasNegocios = response.data;
      });
    },
    edit(formatoInspeccion) {
      return this.$router.push({
        name: "/Admin/FormatosInspeccionForm",
        params: {
          accion: "Editar",
          data_edit: formatoInspeccion,
          id: formatoInspeccion.id,
        },
      });
    },
    exportarPdfEstructura(item) {
      this.cargando = true;
      axios
        .get("/api/admin/formatosInspeccion/" + item.id + "/pdf-estructura")
        .then((response) => {
          this.cargando = false;
          if (response.data.url) {
            window.open(response.data.url, "_blank");
            this.$swal({
              icon: "success",
              title: response.data.message || "PDF generado.",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Error al generar el PDF.",
            text: e.response?.data?.message || "",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
      this.cargando = false;
    },
  },

  mounted() {
    this.getIndex();
    this.getLineasNegocios();
  },
};
</script>
